/* jshint ignore:start */

export function AppController(
  $window,
  $scope,
  $controller,
  $timeout,
  $location,
  sessionService,
) {
  const vm = this;
  angular.extend(vm, $controller('SetupController', { $scope }));

}



// WEBPACK FOOTER //
// ./src/app/app.controller.js